import React from 'react';
import { useRouter } from 'next/router';
import Head from 'next/head';
import TeacherSection from '@/components/teachers/TeacherSection';
import BannerHero from '@/components/bannerHero';
import ContactSection from '@/components/ContactArea';
import { teachers as teachersData } from '@/db/teachersData';

const TeacherDetailPage = () => {
  const router = useRouter();
  const { id } = router.query;

  // Handle loading state
  if (!router.isReady) return null;

  const teacherId = id ? Number(id) : undefined;
  const teacher = teacherId ? teachersData.find(t => t.id === teacherId) : teachersData[0];

  if (!teacher && teacherId) {
    return (
      <div className="text-center py-5">
        <h1>Teacher Not Found</h1>
        <p>The teacher you are looking for does not exist.</p>
      </div>
    );
  }

  // Use the first teacher as a fallback if no ID is provided
  const activeTeacher = teacher || teachersData[0];

  return (
    <>
      <Head>
        <title>{activeTeacher.name} - Cayman Academy</title>
        <meta name="description" content={`Profile of ${activeTeacher.name}, ${activeTeacher.role} at Cayman Academy`} />
      </Head>

      <main>
        <BannerHero
          title={activeTeacher.name}
          bgImage="/images/teachers/teacher-bg2.png"
          className="teacher-details"
        />
        <TeacherSection teacherId={activeTeacher.id} />
        {/* <ContactSection /> */}
      </main>
    </>
  );
};

export default TeacherDetailPage;
